// extracted by mini-css-extract-plugin
module.exports = {"reportBlock":"styles_reportBlock__2cu4F","reportName":"styles_reportName__3rfGb"};